import { useState } from "react";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import FixaButton from "@coworker/apprestructured/src/shared/wrappers/FixaButton/FixaButton";
import InformationCircleIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/InformationCircleIconPath";
import MfaqInfoModal from "./MfaqInfoModal/MfaqInfoModal";
import styles from "./MfaqInfoPanel.module.css";
import { useTranslation } from "@coworker/locales";

type MfaqInfoPanelProps = {
  label: string;
  filterLabel: string;
  upvotes: number;
  location: string;
};

function MfaqInfoPanel({
  label,
  filterLabel,
  upvotes,
  location,
}: MfaqInfoPanelProps) {
  const [infoModalOpen, setInfoModalOpen] = useState(false);
  const { t } = useTranslation();

  return (
    <div className={styles["root"]}>
      <FixaButton
        className={styles["infoButton"]}
        data-testid="mfaq-task-info-button"
        iconOnly
        aria-label={t("mfaqTaskInfoButtonAriaLabelString")}
        ssrIcon={InformationCircleIconPath}
        type="tertiary"
        size="small"
        onClick={() => setInfoModalOpen(true)}
      />
      <FixaText textStyle="Body.M" className={styles["muted"]}>
        {label}
        <span> - {filterLabel}</span>
      </FixaText>
      <FixaText textStyle="Heading.L" tagName="p" className={styles["value"]}>
        {upvotes.toLocaleString()}
      </FixaText>
      <FixaText textStyle="Body.M" className={styles["muted"]}>
        {location}
      </FixaText>
      <MfaqInfoModal
        visible={infoModalOpen}
        onClose={() => setInfoModalOpen(false)}
      />
    </div>
  );
}

export default MfaqInfoPanel;
